interface ClientConfig<T> extends RequestInit {
  token: string
  data: T
}

async function client<T>(
  endpoint: string,
  {
    data,
    token,
    headers: customHeaders,
    ...customConfig
  }: Partial<ClientConfig<T>> = {}
) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(data && { 'Content-Type': 'application/json' }),
      ...customHeaders
    },
    ...customConfig
  }
  const response = await fetch(`${window.location.origin}/-${endpoint}`, config)

  if (response.status === 401) {
    return Promise.reject({ message: 'Please re-authenticate.' })
  }
  const parsedResponse: T = await response.json()

  if (response.ok) {
    return Promise.resolve(parsedResponse)
  }

  return Promise.reject(parsedResponse)
}

export { client }
